import { VonEmployeeRestrictionType } from "../Constants/VON/EmployeeForm/vonEmployeeRestrictionType";

const getRestrictionsForEmployeeType = (employeeType, vonEmployeeTypeRestrictions) => {
    return vonEmployeeTypeRestrictions.filter(
        restriction => restriction.employeeTypeId == employeeType
    );
}

const filterServiceRolesForEmployeeType = (employeeType, serviceRoles, vonEmployeeTypeRestrictions) => {
    const restrictions = getRestrictionsForEmployeeType(employeeType, vonEmployeeTypeRestrictions);

    let usableRoles = [...serviceRoles];

    restrictions.forEach(({ restrictionType, conditions = [] }) => {
        if (!conditions.length) return;

        if (restrictionType === VonEmployeeRestrictionType.AllowedRoles) {
            const allowedRoles = serviceRoles.filter(role => conditions.includes(role.id));
            usableRoles = allowedRoles;
        } else if (restrictionType === VonEmployeeRestrictionType.NotAllowedRoles) {
            usableRoles = usableRoles.filter(role => !conditions.includes(role.id));
        }
    });

    return [{ id: 0, displayName: 'Ej tillgång' }, ...usableRoles];
};

const isLicenseRequiredForEmployee = (account, vonEmployeeTypeRestrictions) => {
    if (!account) return false;
    // If the user is a consultant, they do not require a license
    if (account.consultantId) return false;
    const restrictions = getRestrictionsForEmployeeType(account.employeeType, vonEmployeeTypeRestrictions);
    return !restrictions.some(restriction => restriction.restrictionType === VonEmployeeRestrictionType.DoesNotConsumeLicense);
}

export {
    filterServiceRolesForEmployeeType,
    isLicenseRequiredForEmployee
};